import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["frame"]
  }

  static get values() {
    return { domain: String, source: String, filters: Object, search: Boolean }
  }

  connect() {
    if (this.searchValue) {
      this.load()
    }
  }

  // Set filters passed from other stimulus controllers
  filter({ detail: { name, values } }) {
    let filtersValue = this.filtersValue
    filtersValue[name] = values.length === 0 ? null : values
    this.filtersValue = filtersValue
    this.load()
  }

  // Clear all the filters
  clearFilters() {
    this.filtersValue = {}
    this.load()
  }

  load() {
    let limit = 10
    let offset = 0

    this.frameTarget.src = App.api.domainSearch(
      {
        domain: this.domainValue,
        limit,
        offset,
        type: this.filtersValue.type,
        department: this.filtersValue.department,
        requiredField: this.filtersValue.required_field,
        jobTitles: this.filtersValue.job_titles,
        format: "html",
        source: "discover"
      }
    )
    this.frameTarget.reload()
  }
}
